import React from "react";

import connect from "../../../../../i18n/connect";
import config from "../../../../../config";
import "./AuthGdprFooter.scss";

function AuthGdprFooter({ translate }) {
  return (
    <div
      className={"gdpr-disclaimer"}
      dangerouslySetInnerHTML={{
        __html: translate("gdpr_disclaimer", {
          gdprInfoUrl: config.gdprInfoUrl
        })
      }}
    />
  );
}

export default connect()(AuthGdprFooter);
